var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import styled from "styled-components";
import { DeskPool } from "../../DeskPool";
import { ERoleTypes, getRoleNightActionName, } from "../../../../types";
import { performNightAction } from "../../../../api";
import { selectMatchState, setMatchState } from "../../../../store/match";
import { useAppDispatch, useAppSelector, useQuery } from "../../../../hooks";
import { useErrorHandler } from "../../../../hooks/useErrorHandler";
const Action = styled.div `
  //position: absolute;
  //top: 52%;
  //left: 33.5%;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  //color: #ffffff;
`;
export function RolePerformNightAction() {
    const { param: matchId } = useQuery("matchId");
    const { errorHandler } = useErrorHandler(matchId);
    const dispatch = useAppDispatch();
    const matchState = useAppSelector(selectMatchState);
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const currentRole = useMemo(() => { var _a; return ((_a = matchState === null || matchState === void 0 ? void 0 : matchState.state) === null || _a === void 0 ? void 0 : _a.currentRole) || ERoleTypes.MAFIA; }, [matchState]);
    const performActionHandler = () => __awaiter(this, void 0, void 0, function* () {
        if (!selectedPlayer)
            return;
        setIsLoading(true);
        try {
            const result = yield performNightAction(selectedPlayer.id);
            dispatch(setMatchState(result));
        }
        catch (err) {
            errorHandler(err);
        }
        finally {
            setIsLoading(false);
        }
    });
    const onPlayerClickAction = (playerId) => {
        const player = matchState === null || matchState === void 0 ? void 0 : matchState.players.find((p) => p.id === playerId);
        if (player) {
            setSelectedPlayer(player);
        }
        else {
            setSelectedPlayer(null);
        }
    };
    const gameButtonState = {
        text: isLoading ? 'Выполняется...' : `${getRoleNightActionName(currentRole)}${(selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.player.gameName)
            ? ` ${selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.player.gameName}`
            : "..."}`,
        visible: true,
        disabled: selectedPlayer === null || isLoading,
        onClick: performActionHandler,
    };
    return (_jsx(DeskPool, { onPlayerClickAction: onPlayerClickAction, gameButtonState: gameButtonState }));
}
